import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const SiteUnderConstruction: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    minHeight: '100vh', 
    justifyContent: 'center', 
    background: '#18181b', // near black/darkest grey
    width: '100vw',
    margin: 0,
    padding: 0
  }}>
    <DotLottieReact
      src="https://lottie.host/134e09ef-daad-4485-b683-f1b46da8ba26/29BEr3FLjW.lottie"
      loop
      autoplay
      style={{ width: 400, height: 400 }}
    />
    <h1 style={{ marginTop: 32, fontWeight: 600, fontSize: 32, color: '#fff' }}>Site Under Construction</h1>
    {/* <p style={{ color: '#fff', fontSize: 18, marginTop: 8 }}>We're working hard to bring you something amazing. Stay tuned!</p> */}
  </div>
);

export default SiteUnderConstruction;
